import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useAuthStore = create()(persist((set) => ({
    user: null,
    token: null,
    isAuthenticated: false,
    isImpersonating: false,
    originalAdmin: null,
    originalToken: null,
    login: (user, token) => {
        localStorage.setItem('token', token);
        set({ user, token, isAuthenticated: true });
    },
    adminImpersonation: (user, token, originalAdmin, originalToken) => {
        localStorage.setItem('token', token);
        set({
            user,
            token,
            isAuthenticated: true,
            isImpersonating: true,
            originalAdmin,
            originalToken
        });
    },
    logout: () => {
        localStorage.removeItem('token');
        set((state) => {
            if (state.isImpersonating && state.originalAdmin && state.originalToken) {
                // Return to original admin session
                localStorage.setItem('token', state.originalToken);
                return {
                    user: state.originalAdmin,
                    token: state.originalToken,
                    isAuthenticated: true,
                    isImpersonating: false,
                    originalAdmin: null,
                    originalToken: null
                };
            }
            else {
                // Regular logout
                return {
                    user: null,
                    token: null,
                    isAuthenticated: false,
                    isImpersonating: false,
                    originalAdmin: null,
                    originalToken: null
                };
            }
        });
    },
    updateUser: (userData) => set((state) => ({
        user: state.user ? { ...state.user, ...userData } : null,
    })),
}), {
    name: 'auth-storage',
    partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        isImpersonating: state.isImpersonating,
        originalAdmin: state.originalAdmin,
        originalToken: state.originalToken
    }),
}));
